/**
 * KB 주문 추적 훅
 * 
 * KB 주문 전체 플로우의 의도-결과를 추적
 * - kb_order_start: KB 주문 시작
 * - kb_order_success: KB 주문 성공
 * - kb_order_fail: KB 주문 실패
 * 
 * @example
 * ```tsx
 * function KBOrderPage() {
 *   const kbOrder = useKBOrder();
 *   
 *   useEffect(() => {
 *     // KB 주문 시작
 *     kbOrder.start();
 *   }, []);
 *   
 *   const handleComplete = async () => {
 *     try {
 *       const result = await connectKB(data);
 *       kbOrder.success({ kb_id: result.id });
 *     } catch (error) {
 *       kbOrder.fail('backend_5xx');
 *     }
 *   };
 * }
 * ```
 */

import { useIntent } from '../useIntent';
import { track } from '../../../../core/client';

export interface KBOrderContext {
    order_type: 'buy' | 'sell';
    ticker: string;
    parent_intent_id?: string;
}

export interface KBOrderActions {
    start: (options?: {
        parentIntentId?: string;
        parentIntentType?: string;
        order_type: 'buy' | 'sell';
        ticker: string;
    }) => string;
    success: (context?: KBOrderContext) => void;
    fail: (reason?: string) => void;
}

/**
 * 포트폴리오 생성 플로우 추적 훅
 */
export function useKBOrder(): KBOrderActions {
    const intent = useIntent<KBOrderContext>({
        type: 'kb_order',
        requiredGate: 'login',  // 비회원도 가능
        onStart: ({ intent_id, context }) => {
            track('kb_order_start', {
                intent_id,
                order_type: context?.order_type || 'buy',
                ticker: context?.ticker || '',

            });
        },
        onSuccess: ({ intent_id, context, latency_ms }) => {
            track('kb_order_success', {
                intent_id,
                latency_ms,
            });
        },
        onFail: ({ intent_id, fail_reason }) => {
            track('kb_order_fail', {
                intent_id,
                fail_reason,
            });
        },
    });



    return {
        start: (options) => intent.start(undefined, options),
        success: (context) => intent.success(),
        fail: (reason) => intent.fail(reason),
    };
}

